export default __webpack_public_path__ + "static/media/Existing_Base_Leaders.7795f88a.png";